import { axios } from '@/api/common'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  HolidayCreateModel,
  HolidayCreateSchema,
  HolidayUpdateModel,
  HolidayUpdateSchema,
} from './mutation.schema'

export async function createHoliday(data: HolidayCreateModel): Promise<void> {
  const patch = HolidayCreateSchema.parse(data)
  await axios.post('/api/masterdata/holidays', patch)
}

export const useCreateHolidayMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: createHoliday,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['holidays'] })
    },
  })
}

export async function updateHoliday(data: HolidayUpdateModel): Promise<void> {
  const patch = HolidayUpdateSchema.parse(data)
  await axios.put(`/api/masterdata/holidays/${data.id}`, patch)
}

export const useUpdateHolidayMutation = (id: number) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['holidays', 'update', id],
    mutationFn: updateHoliday,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['holidays'] })
    },
  })
}

// =================  delete party =================

export const useDeleteHolidayMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: number) => axios.delete(`/api/masterdata/holidays/${id}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['holidays'] })
    },
  })
}
